export default {
  templates: [],
};
